// The #DDE5DA line between row groups (Cong, letter 104 1.1.2; the export's #EEF3EC before that): 1px as the design draws it (an inside stroke), and a border,
// not a filled 2px box -- a border width is snapped to whole device pixels, so the line paints the
// same thickness at any y and zoom. README.md ("Subsection divider: 1px, a border").
// `className` carries the margins, which differ per card.
export default function SubsectionDivider({ className, testId }) {
  return <div data-testid={testId} aria-hidden="true" className={`h-0 border-t border-[#DDE5DA] ${className}`} />
}
